function copyText(element) {
  var $copyText = document.getElementById(element).innerText;
  var button = document.getElementById(element + "-button");
  navigator.clipboard.writeText($copyText).then(
    function () {
      var originalText = button.innerText;
      button.innerText = "Copied!";
      button.style.cssText = "color: green;";
      setTimeout(function () {
        button.innerText = originalText;
        button.style.cssText = "color: rgba(var(--color-foreground),.75)";
      }, 2000);
    },
    function () {
      button.style.cssText = "background-color: var(--red);";
      button.innerText = "Error";
    }
  );
}
